module.exports = __webpack_public_path__ + "img/icon_03.f8265ff7.png";